import type { Guest } from '../types';

/** Пара — двусторонняя связь: A.companion_id === B.id или B.companion_id === A.id. */
export function getCompanion(guest: Guest, guests: Guest[]): Guest | null {
  if (guest.companion_id) {
    const direct = guests.find((g) => g.id === guest.companion_id && g.id !== guest.id);
    if (direct) return direct;
  }
  return guests.find((g) => g.companion_id === guest.id && g.id !== guest.id) || null;
}

/** Единицы рассадки: одиночка или пара. Порядок стабилен (по порядку входа). */
export function buildUnits(guests: Guest[]): Guest[][] {
  const seen = new Set<string>();
  const units: Guest[][] = [];
  for (const g of guests) {
    if (seen.has(g.id)) continue;
    seen.add(g.id);
    const c = getCompanion(g, guests);
    if (c && !seen.has(c.id)) {
      seen.add(c.id);
      units.push([g, c]);
    } else {
      units.push([g]);
    }
  }
  return units;
}
